import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UplineRefferelService } from '../services/upline-refferel.service';

@Component({
  selector: 'app-upline-refferel',
  templateUrl: './upline-refferel.component.html',
  styleUrls: ['./upline-refferel.component.scss']
})
export class UplineRefferelComponent {

  form: FormGroup;
  parentMobile: string = '';
  parentReferralCode: string = '';
  parentName: string = '';
  childName:string='';
  childMobile: string = '';
  message: string = '';


    constructor(
      private router: Router,
      private _fb: FormBuilder,
      private service: UplineRefferelService,

    ) {
      this.form = this._fb.group({
        pairId: [''],
        side: [[]],
    
      });
    }
  
    ngOnInit() {
    }
  
    findParentInfo() {
        const payload = {
       parentMobile: this.parentMobile
      };
      this.service.getParrentRefferelcode(payload)
        .subscribe({
          next: (v: any) => {
           this.parentReferralCode = v.result?.ownReferralCode,
           this.parentName = v.result?.firstName
          },
          error: err => {
            console.log(err)
          }
        })
    }

findChildInfo(){
     const payload = {
       parentMobile: this.childMobile
      };
      this.service.getParrentRefferelcode(payload)
        .subscribe({
          next: (v: any) => {
           this.childName = v.result?.firstName
          },
          error: err => {
            console.log(err)
          }
        })
}


 assignReferral() {
  if (!this.childMobile || !this.parentReferralCode) {
    this.message = 'Please enter a valid child mobile and ensure parent referral is available.';
    return;
  }
  const payload = {
    childMobile: this.childMobile,
    referralCode: this.parentReferralCode
  };
  this.service.updateChildRefferelcode(payload)
    .subscribe({
      next: (res: any) => {
        this.message = `Referral code ${this.parentReferralCode} successfully assigned to ${this.childMobile}`;
      },
      error: err => {
        console.error(err);
        this.message = 'Failed to assign referral code. Please try again.';
      }
    });
}

}
